import { Fragment, useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Button from '~~elements/Button';
import Loading from '~~elements/Loading';
import { PHONE_WIDTH, TABLET_WIDTH, COLOR, FONT_COLOR } from '~~elements/Const';
import { plugins } from './Const';
import { useRootState } from '../../useRoot';
import { usePluginShopDispatch } from './usePluginShop';

const StyledDiv = styled.div`
  width: 100%;
  padding: 2rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;

  .plugin {
    width: 1080px;
    max-width: 90%;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
    row-gap: 1rem;
  }

  .breadcrumbs {
    display: flex;
    align-items: center;
    align-self: flex-start;
    gap: 0.5rem;
  }

  .main {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: flex-start;
    gap: 2rem;
    .showcase {
      width: 100%;
      .main-photo-space {
        width: 100%;
        position: relative;
        text-align: start;
        background-color: #fafafa;
        &:after {
          content: '';
          display: block;
          padding-bottom: 100%;
        }
        .photo {
          cursor: default;
        }
      }
      .photo-list {
        margin-top: 1rem;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: start;
        gap: 0.5rem;
        flex-wrap: wrap;
        .photo-space {
          width: 5rem;
          position: relative;
          text-align: start;
          &:after {
            content: '';
            display: block;
            padding-bottom: 100%;
          }
        }
      }
      .photo {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: fill;
        object-position: center;
        cursor: pointer;
        &--focused {
          position: absolute;
          width: 100%;
          height: 100%;
          background-color: rgba(255, 255, 255, 0.2);
        }
      }
    }
    .intro {
      text-align: start;
      width: 100%;
      .name {
        font-size: 1.8rem;
        line-height: 1.4;
        font-weight: 700;
        margin: 0 0 1rem;
        color: ${COLOR.secondary};
      }
      .price {
        font-size: 1.5rem;
        font-weight: 400;
        letter-spacing: 2px;
        margin: 0 0 1.5rem;
        color: ${COLOR.primary};
      }
    }
  }

  .buy-space {
    padding: 0.5rem;
    display: flex;
    flex-direction: column;
    > i {
      font-size: 0.9rem;
    }
    button {
      font-size: 1rem;
    }
    .buy {
      display: flex;
      align-items: center;
      justify-content: start;
      gap: 0.5rem;
    }
  }

  .about {
    padding: 0.5rem;
    .header {
      width: 100%;
      font-size: 1.3rem;
      font-weight: 400;
      margin: 0 0 0.2rem;
      padding: 0 0 0.2rem;
      border-bottom: 2px solid ${COLOR.secondary};
    }
    .paragraph {
      line-height: 1.3;
      font-size: 1rem;
      padding: 0.2rem;
      &.admonition {
        color: ${FONT_COLOR};
        font-size: 0.9;
      }
    }
    .links {
      display: flex;
      gap: 1rem;
      flex-wrap: warp;
    }
  }

  @media (max-width: ${TABLET_WIDTH}) {
    .main {
      gap: 1rem;
      .showcase {
        .photo-list {
          margin-top: 0.8rem;
          .photo-space {
            width: 3rem;
          }
        }
      }
    }
  }

  @media (max-width: ${PHONE_WIDTH}) {
    .main {
      grid-template-columns: 1fr;
      align-items: flex-start;
      gap: 1rem;
      .intro {
        .name {
          font-size: 1.5rem;
        }
        .price {
          font-size: 1.2rem;
          letter-spacing: 1px;
        }
      }
    }

    .about {
      .header {
        font-size: 1rem;
      }
      .paragraph {
        font-size: 0.8rem;
      }
    }
  }
`;

const getEmptyPlugin = () => ({
  pluginTarget: '',
  pluginName: '',
  src: '',
  alt: '',
  name: '',
  price: '',
  photos: [],
  deposit: false,
  description: [],
  admonition: [],
  relatedLinks: [],
});

const PluginShop = () => {
  const {
    loginInfo: { isLogin },
  } = useRootState();
  const dispatch = usePluginShopDispatch();

  const { plugin_name: pluginName } = useParams();
  const history = useHistory();

  const [plugin, setPlugin] = useState(getEmptyPlugin());

  const [photos, setPhotos] = useState(['']);
  const [photoFocus, setPhotoFocus] = useState(0);

  const [amount, setAmount] = useState(1);
  const [dispatchWaiting, setDispatchWaiting] = useState(false);

  useEffect(() => {
    setPhotoFocus(0);
    setPhotos(['']);
    setAmount(1);
    setDispatchWaiting(false);
    if (!plugins[pluginName]) {
      setPlugin(getEmptyPlugin());
      history.replace(`/shop/plugin`);
      return;
    }

    setPlugin(plugins[pluginName]);
    setPhotos([plugins[pluginName].src, ...plugins[pluginName].photos]);
  }, [pluginName, history]);

  const handlePhotoChange = (index) => () => {
    setPhotoFocus(index);
  };

  const addAmount = () => {
    setAmount(amount + 1);
  };

  const minusAmount = () => {
    setAmount(amount - 1);
  };

  const showParchasePage = () => {
    setDispatchWaiting(true);
    dispatch({
      type: 'purchasePage',
      payload: { amount, pluginTarget: plugin.pluginTarget, pluginName: plugin.pluginName },
    });

    setTimeout(() => {
      setDispatchWaiting(false);
      history.push(`/shop/plugin/payment`);
    }, 1000);
  };

  return (
    <StyledDiv>
      <div className="plugin">
        <nav className="breadcrumbs">
          <span>/</span>
          <Link to="/shop/plugin">擴充套件</Link>
        </nav>
        <div className="main">
          <div className="showcase">
            <div className="main-photo-space">
              <img className="photo" src={photos[photoFocus]} alt={plugin.alt} />
            </div>
            <div className="photo-list">
              {photos.map((src, index) => (
                <div key={index} className="photo-space">
                  <img className="photo" src={src} alt={`demo-${index}`} onClick={handlePhotoChange(index)} />
                  {photoFocus === index && <div className="photo--focused" />}
                </div>
              ))}
            </div>
          </div>
          <div className="intro">
            <h1 className="name">{plugin.name}</h1>
            <h3 className="price">{plugin.price}</h3>
            <div className="buy-space">
              {plugin.deposit && <i>線上僅需支付訂金$1,000，完成交易後我們會以電子信箱與您聯絡了解需求</i>}
              {!isLogin ? (
                <Link to={`/login?done_url=${encodeURIComponent(window.location.href)}`}>
                  <Button>請先登入</Button>
                </Link>
              ) : plugin.deposit ? (
                <Button onClick={showParchasePage} disabled={dispatchWaiting}>
                  {dispatchWaiting ? <Loading width="1.5rem" margin="0 auto" /> : '立刻購買'}
                </Button>
              ) : (
                <div className="buy">
                  <Button
                    width="2rem"
                    color="transparent"
                    disabled={amount === 1 || dispatchWaiting}
                    onClick={minusAmount}
                  >
                    -
                  </Button>
                  <span style={{ width: '3rem', textAlign: 'center' }}>{amount}</span>
                  <Button width="2rem" color="transparent" onClick={addAmount} disabled={dispatchWaiting}>
                    +
                  </Button>
                  <Button onClick={showParchasePage} disabled={dispatchWaiting}>
                    {dispatchWaiting ? <Loading width="1.5rem" margin="0 auto" /> : '立刻購買'}
                  </Button>
                </div>
              )}
            </div>
            <div className="about">
              <h3 className="header">關於服務</h3>
              {plugin.description.map((des, i) => (
                <p key={i} className="paragraph">
                  {des}
                </p>
              ))}
              {plugin.admonition.map((adm, i) => (
                <p key={i} className="paragraph admonition">
                  *{adm}
                </p>
              ))}
              {plugin.relatedLinks.length > 0 && (
                <Fragment>
                  <h3 className="header">參考連結</h3>
                  <div className="links">
                    {plugin.relatedLinks.map((l) => (
                      <a key={l.name} href={l.link} target="_blank" rel="noreferrer">
                        {l.name}
                      </a>
                    ))}
                  </div>
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </StyledDiv>
  );
};

export default PluginShop;
